import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BRAND } from "@/lib/data";

export const Preloader = () => {
  const [show, setShow] = useState(() => {
    try {
      return !sessionStorage.getItem("lc_intro");
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!show) return;
    try {
      sessionStorage.setItem("lc_intro", "1");
    } catch {}
    const t = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center gap-6"
        >
          <motion.img
            src={BRAND.logo}
            alt="La Contadina"
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="h-28 w-28 md:h-36 md:w-36 rounded-full object-cover ring-2 ring-gold/40"
          />
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.6, ease: "easeInOut" }}
            className="h-px w-40 bg-gold/60 origin-left"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
